/* global params,google */
import 'bootstrap';
import '@fancyapps/fancybox';
import fitvids from 'fitvids';
import './objectFitFallback.js';

// Make all videos responsive
fitvids();

(function($){

// CAROUSELS
$('.slider').slick({
  autoplay: true,
  arrows: false,
  swipe: true,
  dots: true,
  useTransform: false,
  autoplaySpeed: 3000,
  adaptiveHeight: true
});
$('.slider-mob').slick({
  autoplay: true,
  arrows: false,
  swipe: true,
  dots: false,
  useTransform: false,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplaySpeed: 3000
});

// MODALS
var modal;
// Load  content into modals when .popup class is present
$(document).on('click', 'a.popup', function(e){
  e.preventDefault();
  $('#modal .modal-body').load($(this).attr("href")+"?modal");
  $('#modal').modal('show');
});

// Unload modal content when closed
$(document).on('hidden.bs.modal', '#modal', function () {
  $('#modal .modal-body').html('<div class="modal-loader"><img src="'+params.theme_url+'/images/tail-spin.svg" alt="Loading"/></div>');
});

function setModal(type,title,body) {
  modal.find('.modal-content').removeClass().addClass('modal-content '+type);
  if(title !=='') {
    modal.find('.modal-title').html(title);
  }
  if(body !=='') {
    modal.find('.modal-body').html(body);
  }
}
function showModal(type,title,body) {
  setModal(type,title,body);
  modal.modal('show');
}

// FIELDS & LABELS

var field,
    field_block;

// Float Labels

// Add focus class to filled fields on page load
$(function(){
  $('.float-label input').filter(function () {
    if(this.value.length > 0) {
      $(this).closest(".float-label").addClass("focus");
    }
  });
});

// When field is focussed
$(document).on("focus", ".float-label .form-control", function() {
  field = $(this); 
  field_block = field.closest(".float-label");
  if(!field.prop('disabled'))
  {
    field_block.addClass("focus");
  }
});

// When field loses focus
$(document).on("blur", ".form-control", function() {
  field = $(this);
  field_block = field.closest(".float-label");
  if(field.val().length === 0) {
    field_block.removeClass("focus");
  }
});

// FORM SUBMISSIONS
/*----------------------------------------------------------------------------*/
var form,
		btn,
		formdata;
$(document).on("submit", ".tr_form", function(e) {
  e.preventDefault();
  form = $(this);
  btn = form.find('input[type=submit]');
  modal = form.find('.modal');
  var feedback = form.find('.feedback');
  //Capture new form data
  formdata = form.serializeArray();
  formdata.push({
      "name": "submit",
      "value": 1
  });

  $(".formdata").each(function(){
    if($(this).attr("type") === 'checkbox')
    {
      if($(this).prop("checked") === true)
      {
        formdata.push({
            "name": this.name,
            "value": $(this).val()
        });
      }
    }
    else
    {
      formdata.push({
          "name": this.name,
          "value": $(this).val()
      });
    }
	});

  //Disable the save button and add "waiting" status
  btn.prop("disabled",true).addClass("running");
  //Remove error styling on all fields
  form.find(".field,.field input,.field textarea,.field select").removeClass("is-invalid").closest(".field").find('.invalid-feedback').remove();

  //Save the data
  if(formdata.length) {
    $.ajax({
			url:  params.ajax_url,
			type: 'post',                
			data: formdata,
      dataType: "json"
    })
    .done(function(data) {
      if(data.success)
      {
        //Enable save button
        setTimeout(function(){
          btn.prop("disabled",false).removeClass("running");
        }, 1000);

        //Display success message
        if(modal.length) {
          showModal('success','Thank you',data.success);
        }
        else if(feedback.length) {
          feedback.html('<div class="alert alert-success mt-3" role="alert">'+data.success+'</div>');
        }

        //Reset the form
        form.trigger("reset");

        form.find(".field").removeClass("focus").removeClass("is-invalid").val(null);

        form.find("select[multiple]").val(null).trigger('change');
      }
      else
      {
        if(!$.isEmptyObject(data.errors))
        {
          $.each(data.errors,function(i,val) {
            form.find(".field [name^='"+i+"']").addClass("is-invalid")
                                    .closest(".field").addClass("is-invalid").append('<p class="invalid-feedback">'+val+'</p>');
            if(modal.length) {
              if(data.errors.dummy) {
                showModal('error','There was a problem',data.errors.dummy);
              }
              else {
                showModal('error','There was a problem','We couldn\'t submit this form.  Please correct the marked fields and try again.');
              }
            }
            else if(feedback.length) {
              if(data.errors.dummy) {
                feedback.html('<div class="alert alert-danger mt-3" role="alert">'+data.errors.dummy+'</div>');
              }
            }

          });
        }
      }

      //Enable save button
      setTimeout(function(){
        btn.prop("disabled",false).removeClass("running");
      }, 1000);
    });
  }
});

// Google maps

/**
 * initMap
 *
 * Renders a Google Map onto the selected jQuery element
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @return  object The map instance.
 */
function initMap( $el ) {

    // Find marker elements within map.
    var $markers = $el.find('.marker');

    // Create gerenic map.
    var mapArgs = {
        zoom        : $el.data('zoom') || 16,
        mapTypeId   : google.maps.MapTypeId.ROADMAP
    };
    var map = new google.maps.Map( $el[0], mapArgs );

    // Add markers.
    map.markers = [];
    $markers.each(function(){
        initMarker( $(this), map );
    });

    // Center map based on markers.
    centerMap( map );

    // Return map instance.
    return map;
}

/**
 * initMarker
 *
 * Creates a marker for the given jQuery element and map.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @param   object The map instance.
 * @return  object The marker instance.
 */
function initMarker( $marker, map ) {

    // Get position from marker.
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var latLng = {
        lat: parseFloat( lat ),
        lng: parseFloat( lng )
    };

    // Create marker instance.
    var marker = new google.maps.Marker({
        position : latLng,
        map: map
    });

    // Append to reference for later use.
    map.markers.push( marker );

    // If marker contains HTML, add it to an infoWindow.
    if( $marker.html() ){

        // Create info window.
        var infowindow = new google.maps.InfoWindow({
            content: $marker.html()
        });

        // Show info window when marker is clicked.
        google.maps.event.addListener(marker, 'click', function() {
            infowindow.open( map, marker );
        });
    }
}

/**
 * centerMap
 *
 * Centers the map showing all markers in view.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   object The map instance.
 * @return  void
 */
function centerMap( map ) {

    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function( marker ){
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    // Case: Single marker.
    if( map.markers.length == 1 ){
        map.setCenter( bounds.getCenter() );

    // Case: Multiple markers.
    } else{
        map.fitBounds( bounds );
    }
}

// Render maps on page load.
$(function(){
  let bannerMap = $('.banner-map');
  if(bannerMap.length) {
    bannerMap.each(function(){
      initMap( $(this) );
    });
  }
});

})(jQuery);